import { ParsedUrlQuery } from 'querystring';
import {
  EMPTY_PHONE_NUMBER_FILTER,
  PHONE_NUMBER_OPERATOR_LENGTH,
  PHONE_NUMBER_PROPERTY_LEGACY_ID,
  PHONE_NUMBER_WILDCARD,
} from '@/features/PhoneNumberSearch/constants';
import { toPhoneNumberFilter } from '@/features/PhoneNumberSearch/helpers';
import { QUERY } from '@/constants/common';

const DIGIT_PATTERN = /^\d$/;

export function getPhoneNumberFilterDraftParts(phoneNumberFilter: string): {
  operatorCode: string | null;
  subscriberDigits: string[];
} {
  const operatorPart = phoneNumberFilter.slice(0, PHONE_NUMBER_OPERATOR_LENGTH);

  return {
    operatorCode: /^\d{3}$/.test(operatorPart) ? operatorPart : null,
    subscriberDigits: phoneNumberFilter
      .slice(PHONE_NUMBER_OPERATOR_LENGTH)
      .split('')
      .map(char => (DIGIT_PATTERN.test(char) ? char : '')),
  };
}

export function updatePhoneNumberFilter(
  phoneNumberFilter: string,
  patch: {
    operatorCode?: string | null;
    subscriberDigit?: { index: number; value: string };
  }
) {
  const chars = toPhoneNumberFilter(phoneNumberFilter).split('');
  const { operatorCode, subscriberDigit } = patch;

  if (operatorCode !== undefined) {
    const nextOperator =
      operatorCode ??
      PHONE_NUMBER_WILDCARD.repeat(PHONE_NUMBER_OPERATOR_LENGTH);
    nextOperator.split('').forEach((char, index) => {
      chars[index] = char;
    });
  }

  if (subscriberDigit) {
    const { index, value } = subscriberDigit;
    const position = PHONE_NUMBER_OPERATOR_LENGTH + index;
    chars[position] = DIGIT_PATTERN.test(value) ? value : PHONE_NUMBER_WILDCARD;
  }

  return chars.join('');
}

export function buildPhoneNumberSearchQuery(
  query: ParsedUrlQuery,
  nextFilter: string,
  clearKeywords: boolean
): ParsedUrlQuery {
  const nextQuery: ParsedUrlQuery = { ...query };
  const phoneNumberKey = `p[${PHONE_NUMBER_PROPERTY_LEGACY_ID}]`;
  const keywordsKey = `${QUERY.q}[${QUERY.keywords}]`;

  if (nextFilter === EMPTY_PHONE_NUMBER_FILTER) {
    delete nextQuery[phoneNumberKey];
  } else {
    nextQuery[phoneNumberKey] = nextFilter;
  }

  if (clearKeywords) {
    delete nextQuery[keywordsKey];
    delete nextQuery[QUERY.keywordsSource];
  }

  return nextQuery;
}
